// store/rootReducer.ts
import { combineReducers, type UnknownAction } from '@reduxjs/toolkit';

import registrationReducer from '@/store/slices/registration/registrationSlice'
import authReducer from '@/store/slices/auth/authSlice';
import organizationReducer from '@/store/slices/organization/organizationSlice';
import userReducer from '@/store/slices/user/userSlice';
import SixDetailReducer from '@/store/slices/sixDetail/sixDetailSlice';
import CreateSixReducer from '@/store/slices/createSix/createSixSlice';
import SixCatalogReducer from '@/store/slices/sixCatalog/sixCatalogSlice';
import UIReducer from '@/store/slices/ui/uiSlice';
import ManageAccessReducer from '@/store/slices/manageAccess/manageAccessSlice';
import connectionReducer from '@/store/slices/poc/connectionSlice';
import messagingReducer from '@/store/slices/poc/messagingSlice';
import heliaReducer from '@/store/slices/poc/heliaSlice';
import cloneQueueReducer from '@/store/slices/poc/cloneQueueSlice';
import fileKeyFacilitationReducer from '@/store/slices/fileKey/fileKeyFacilitationSlice';
import debugReducer from '@/store/slices/debug/debugSlice';
import { logoutThunk } from '@/store/thunks/auth/logoutThunk';

const appReducer = combineReducers({
  registration: registrationReducer,
  auth: authReducer,
  organization: organizationReducer,
  user: userReducer,
  sixDetail: SixDetailReducer,
  createSix: CreateSixReducer,
  sixCatalog: SixCatalogReducer,
  ui: UIReducer,
  manageAccess: ManageAccessReducer,
  connection: connectionReducer,
  messaging: messagingReducer,
  helia: heliaReducer,
  cloneQueue: cloneQueueReducer,
  fileKeyFacilitation: fileKeyFacilitationReducer,
  debug: debugReducer,
  // Add other reducers here as your app grows
});

export const rootReducer = (
  state: ReturnType<typeof appReducer> | undefined,
  action: UnknownAction
) => {
  if (action.type === logoutThunk.fulfilled.type) {
    return appReducer(undefined, action);
  }

  return appReducer(state, action);
};

// Infer the `RootState` type from the root reducer
export type RootState = ReturnType<typeof appReducer>;
